// src/modules/fullscreenModule.js

export const requestFullScreen = () => {
  if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    document.documentElement.webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) {
    document.documentElement.msRequestFullscreen();
  }
};

export const exitFullScreen = () => {
  const doc = document;
  if (
    doc.fullscreenElement ||
    doc.webkitFullscreenElement ||
    doc.mozFullScreenElement ||
    doc.msFullscreenElement
  ) {
    if (doc.exitFullscreen) {
      doc.exitFullscreen().catch((err) => {
        console.error("exitFullscreen error:", err);
      });
    } else if (doc.mozCancelFullScreen) {
      doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
      doc.webkitExitFullscreen();
    } else if (doc.msExitFullscreen) {
      doc.msExitFullscreen();
    }
  } else {
    console.warn("No element is in fullscreen mode.");
  }
};


export const handleFullScreenChange = (callback) => {
  const fullScreenChangeHandler = () => {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      callback(false);
    } else {
      callback(true);
    }
  };

  // Listen to full-screen change events
  document.addEventListener('fullscreenchange', fullScreenChangeHandler);
  document.addEventListener('mozfullscreenchange', fullScreenChangeHandler);
  document.addEventListener('webkitfullscreenchange', fullScreenChangeHandler);
  document.addEventListener('msfullscreenchange', fullScreenChangeHandler);

  // Return a cleanup function to remove event listeners
  return () => {
    document.removeEventListener('fullscreenchange', fullScreenChangeHandler);
    document.removeEventListener('mozfullscreenchange', fullScreenChangeHandler);
    document.removeEventListener('webkitfullscreenchange', fullScreenChangeHandler);
    document.removeEventListener('msfullscreenchange', fullScreenChangeHandler);
  };
};
